import { useEffect, useState } from "react";
import { makeStyles, Typography, Box, Grid } from "@material-ui/core";
import { useSelector } from "react-redux";

import { COLORS } from "../../../../../theme/colors";
import { Toggle } from "../../../../../components/toggle";
import { ShaDowBox } from "../../../../../components/boxes";
import { NoDataCard } from "../../../../../components/parts";
import { CustomPieChart } from "../../../../../components/charts";
import { getData, onlyUniqueValuesInObject } from "../../../../../services";

const useStyles = makeStyles(() => ({
  graphUnit: {
    display: "flex",
    alignItems: "center",
    width: "fit-content",
    flexWrap: "nowrap",
  },
  box: {
    marginTop: 15,
    height: 300,
    backgroundColor: COLORS.darks[0][3],
  },
}));

export const PowerConsumptionUsageType = ({ buildingId, complexId, title }) => {
  const classes = useStyles();
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);
  const GRAPH_UNITS = ["kWh", currencySymbol];
  const [byFilter, setByFilter] = useState(GRAPH_UNITS[0]);
  const [chartData, setChartData] = useState([]);

  let url = `/praas/v2/buildings/properties/consumption-usage/?type=${byFilter}`;

  if (buildingId) {
    url = `/praas/v2/buildings/${buildingId}/properties/consumption-usage/?type=${byFilter}`;
  } else if (complexId) {
    url = `/praas/v2/complexes/${complexId}/properties/consumption-usage/?type=${byFilter}`;
  }

  useEffect(() => {
    getData(url, (data) => {
      const unit = byFilter === GRAPH_UNITS[0] ? "kwh" : currencySymbol;
      if (!onlyUniqueValuesInObject(data, 0)) {
        setChartData([
          {
            name: "Public area",
            value: data.public,
            color: COLORS.purple,
            unit: unit,
          },
          {
            name: "Tenants units",
            value: data.tenants,
            color: "#DD87D2",
            unit: unit,
          },
        ]);
      }
    });

    return () => setChartData([]);
  }, [complexId, buildingId, byFilter]);

  if (!chartData.length) {
    return <NoDataCard title={title} type="pie" />;
  }

  return (
    <ShaDowBox fullHeight>
      <Box style={{ padding: 24 }}>
        <Grid container>
          <Grid item xs>
            <Typography variant="h4">{title}</Typography>
          </Grid>
          <Grid item xs={3} className={classes.graphUnit}>
            <Typography style={{ marginRight: 4 }} variant="body2">
              By:
            </Typography>
            <Toggle
              value={byFilter}
              options={GRAPH_UNITS}
              onChanged={setByFilter}
              styles={{ width: 30, fontSize: 12 }}
            />
          </Grid>
        </Grid>
        <Box className={classes.box}>
          <CustomPieChart
            name={byFilter === GRAPH_UNITS[0] ? "PowerConsumptionKwh" : "PowerConsumption"}
            data={chartData}
          />
        </Box>
      </Box>
    </ShaDowBox>
  );
};
